import { render } from "./EmailBody.vue?vue&type=template&id=165177a8&ts=true"
import script from "./EmailBody.vue?vue&type=script&lang=ts"
export * from "./EmailBody.vue?vue&type=script&lang=ts"

import "./EmailBody.vue?vue&type=style&index=0&id=165177a8&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__